import { Component } from '@angular/core';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
} from '@richardlt/ng2-semantic-ui';

interface IViewAlertModalContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-view-alert-modal',
  templateUrl: './view-alert-modal.component.html',
  styleUrls: ['./view-alert-modal.component.scss'],
})
export class ViewAlertModalComponent {
  constructor(public modal: SuiModal<IViewAlertModalContext, void, void>) {
    console.log(modal.context);
  }

  parseJson(jsonString: string) {
    return JSON.parse(jsonString);
  }
}

export class ViewAlertModal extends ComponentModalConfig<
  IViewAlertModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Tiny) {
    super(ViewAlertModalComponent, {
      title,
      data,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
